import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CorePipesModule } from '@core/pipes/pipes.module';

import { CoreCommonModule } from '@core/common.module';

import { AuthForgotPasswordV1Component } from 'app/main/pages/authentication/auth-forgot-password-v1/auth-forgot-password-v1.component';
import { AuthForgotPasswordV2Component } from 'app/main/pages/authentication/auth-forgot-password-v2/auth-forgot-password-v2.component';

import { AuthFirstAccessComponent } from './auth-first-access/auth-first-access.component';

import { AuthLoginV1Component } from 'app/main/pages/authentication/auth-login-v1/auth-login-v1.component';
import { AuthLoginV2Component } from 'app/main/pages/authentication/auth-login-v2/auth-login-v2.component';

import { AuthRegisterV1Component } from 'app/main/pages/authentication/auth-register-v1/auth-register-v1.component';
import { AuthRegisterV2Component } from 'app/main/pages/authentication/auth-register-v2/auth-register-v2.component';
import { AuthRegisterInviteComponent } from 'app/main/pages/authentication/auth-register-invite/auth-register-invite.component';
import { AuthApprovePaymentComponent } from 'app/main/pages/authentication/auth-approve-payment/auth-approve-payment.component';

import { AuthOverduePaymentComponent } from 'app/main/pages/authentication/auth-overdue-payment/auth-overdue-payment.component';

import { AuthResetPasswordV1Component } from 'app/main/pages/authentication/auth-reset-password-v1/auth-reset-password-v1.component';
import { AuthResetPasswordV2Component } from 'app/main/pages/authentication/auth-reset-password-v2/auth-reset-password-v2.component';

import { CoreTouchspinModule } from '@core/components/core-touchspin/core-touchspin.module';

import { DragulaModule } from 'ng2-dragula';
import { GoogleService } from '../../../../services/google.service';
import { NgxMaskModule } from 'ngx-mask';


// routing
const routes: Routes = [
  {
    path: 'authentication/login-v1',
    component: AuthLoginV1Component
  },
  {
    path: 'authentication/login-v2',
    component: AuthLoginV2Component
  },
  {
    path: 'authentication/register-v1',
    component: AuthRegisterV1Component
  },
  {
    path: 'authentication/register-v2',
    component: AuthRegisterV2Component
  },
  {
    path: 'authentication/register-invite',
    component: AuthRegisterInviteComponent
  },
  {
    path: 'authentication/approve-payment',
    component: AuthApprovePaymentComponent
  },
  {
    path: 'authentication/first-access',
    component: AuthFirstAccessComponent
  },
  {
    path: 'authentication/overdue-payment',
    component: AuthOverduePaymentComponent
  },
  {
    path: 'authentication/reset-password-v1',
    component: AuthResetPasswordV1Component
  },
  {
    path: 'authentication/reset-password-v2',
    component: AuthResetPasswordV2Component
  },
  {
    path: 'authentication/forgot-password-v1',
    component: AuthForgotPasswordV1Component
  },
  {
    path: 'authentication/forgot-password-v2',
    component: AuthForgotPasswordV2Component
  }
];

@NgModule({
  declarations: [
    AuthLoginV1Component,
    AuthRegisterV1Component,
    AuthLoginV2Component,
    AuthRegisterV2Component,
    AuthRegisterInviteComponent,
    AuthApprovePaymentComponent,
    AuthOverduePaymentComponent,
    AuthForgotPasswordV1Component,
    AuthForgotPasswordV2Component,
    AuthResetPasswordV1Component,
    AuthResetPasswordV2Component,
    AuthFirstAccessComponent
  ],
  imports: [CommonModule, RouterModule.forChild(routes), NgbModule, NgxMaskModule.forRoot(), FormsModule, ReactiveFormsModule, CoreCommonModule, CorePipesModule, CoreTouchspinModule, DragulaModule.forRoot()],
  providers: [
    GoogleService,
  ],
})
export class AuthenticationModule {}
